import React from "react";

// icons
import HomeIcon from "@assets/svg/HomeIcon";
import ProfileIcon from "@assets/svg/ProfileIcon";
import SearchHome from "@assets/svg/SearchHome";
import DiscountIcon from "@assets/svg/DiscountIcon";
import YourStoreIcon from "@assets/svg/YourStoreIcon";
import AppIcon from "@assets/svg/AppIcon";
import TrainingIcon from "@assets/svg/LeaderTraining";
import CustomerIcon from "../assets/svg/CustomerIcon";
import OrdersIcon from "../assets/svg/OrdersIcon";
import GullakIcon from "../assets/svg/GullakIcon";
import CommunityIcon from "../assets/svg/Community";
import Delivery from "../assets/svg/Delivery";
import Calendar3 from "../assets/svg/Calendar3";

// eslint-disable-next-line import/no-named-as-default
import t from "../constants/localization";
import { GIGS_COPY } from "../screens/Gigs/copy";

const PATH = "navConfig";

const getNavConfig = () => {
  return {
    RateOrder: {
      header: false,
    },
    PageNotFound: {
      header: false,
    },
    MainApp: {
      header: false,
    },
    SignIn: {
      header: false,
    },
    NotServicable: {
      header: false,
    },
    OtpScreen: {
      header: true,
      rightIcon: <AppIcon />,
    },
    Home: {
      bottomTabIcon: HomeIcon,
      label: t(`${PATH}/home`),
    },
    Training: {
      bottomTabIcon: TrainingIcon,
      label: t(`${PATH}/training`),
    },
    Orders: {
      bottomTabIcon: OrdersIcon,
      label: t(`${PATH}/orders`),
    },
    Profile: {
      bottomTabIcon: ProfileIcon,
      label: t(`${PATH}/profile`),
    },
    Gullak: {
      bottomTabIcon: GullakIcon,
      label: t(`${PATH}/wallet`),
    },
    TestOrderTracking: {
      bottomTabIcon: CommunityIcon,
      label: t(`${PATH}/tracking`),
    },
    StaticPages: {
      header: true,
    },
    AddUser: {
      header: true,
      headerColor: "#F6F7F9",
      dynamicTitleRead: true,
      title: null,
    },
    OrderDetails: {
      header: false,
      title: null,
      dynamicTitleRead: true,
      onCloseNavigateTo: "YourStore",
    },
    OrderedProducts: {
      header: true,
      title: t(`${PATH}/orderList`),
    },
    ImportantLinks: {
      header: true,
      title: t(`${PATH}/importantLinks`),
    },
    // Search: {
    //   header: true,
    //   title: "Search",
    //   bottomTabIcon: SearchIcon
    // },
    Catalogue: {
      bottomTabIcon: YourStoreIcon,
    },
    NewOrderPlaceScreen: {
      header: true,
      title: t(`${PATH}/selectItems`),
      rightIcon: <SearchHome />,
      // rightIconClickRedirect: "SearchProductsForCart",
      navState: { viewType: "cart" },
      shouldEmitEvent: true,
    },
    ConfirmOrder: {
      header: true,
      title: null,
      dynamicTitleRead: true,
      headerStyle: {
        color: "#000",
        fontSize: 20,
        fontWeight: "bold",
      },
    },
    AddProductRequest: {
      header: true,
      title: t(`${PATH}/requestProduct`),
    },
    ProductRequests: {
      header: true,
      title: t(`${PATH}/requestedItems`),
    },
    Offers: {
      bottomTabIcon: DiscountIcon,
    },
    Customers: {
      bottomTabIcon: CustomerIcon,
      label: t(`${PATH}/customers`),
    },
    MyDeliveries: {
      bottomTabIcon: Delivery,
      label: t(`${PATH}/myDeliveries`),
    },
    TeamLeaderOffer: {
      header: true,
      title: t(`${PATH}/teamLeaderOffer`),
    },
    BankDetailsForm: {
      header: true,
      title: null,
      dynamicTitleRead: true,
    },
    SupportTree: {
      header: true,
    },
    SupportItem: {
      header: true,
    },
    SupportTickets: {
      header: true,
    },
    SupportTicket: {
      header: true,
    },
    CouponScreen: {
      header: true,
      title: t(`${PATH}/applyCoupon`),
      headerStyle: {
        color: "#000",
        fontSize: 20,
        fontWeight: "bold",
      },
    },
    GroupBuyDetails: {
      header: true,
      title: t(`${PATH}/groupOffer`),
    },
    GroupBuyCustomers: {
      header: true,
      title: t(`${PATH}/selectQuantity`),
    },
    ProductDetails: {
      header: false,
    },
    GigsMarking: {
      header: true,
      title: GIGS_COPY.navTitle,
      rightIcon: <Calendar3 />,
      rightIconClickRedirect: "GigsHistory",
    },
    GigsHistory: {
      header: true,
      title: GIGS_COPY.historyNavTitle,
    },
  };
};

export default getNavConfig;
